import { render, staticRenderFns } from "./AddWallet.vue?vue&type=template&id=530426ba"
import script from "./AddWallet.vue?vue&type=script&lang=js"
export * from "./AddWallet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports